import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface Treatment {
  category: string
  medication: string
  quantity: string
  instructions: string[]
  isPrimary: boolean
  isSecondary: boolean
  isExtra: boolean
}

export interface DiagnosisData {
  condition: string
  description: string
  symptoms: string[]
  redFlags: string[]
  diagnosis: string[]
  causes: string[]
  prevention: string[]
  treatments: Treatment[]
  imageUrls: string[]
}

interface DiagnosisState {
  diagnosisData: DiagnosisData[] | null
  showDiagnosis: boolean
  consentChecked: boolean
  setDiagnosis: (data: DiagnosisData[] | null) => void
  setShowDiagnosis: (show: boolean) => void
  setConsentChecked: (checked: boolean) => void
  resetDiagnosis: () => void
}

export const useDiagnosisStore = create<DiagnosisState>()(
  persist(
    (set) => ({
      diagnosisData: null,
      showDiagnosis: false,
      consentChecked: false,
      setDiagnosis: (data) => set({ diagnosisData: data }),
      setShowDiagnosis: (show) => set({ showDiagnosis: show }),
      setConsentChecked: (checked) => set({ consentChecked: checked }),
      resetDiagnosis: () =>
        set({
          diagnosisData: null,
          showDiagnosis: false,
          consentChecked: false,
        }),
    }),
    {
      name: "alfie-diagnosis-storage",
    },
  ),
)
